export const sanitizeCustomId = (customId: string) => {
  return customId.replace(/[^a-zA-Z0-9_]/g, "");
};
